module.exports = __webpack_public_path__ + "img/ovens.85994341.png";